// SKUWeightQuestion.jsx
import React from "react";
import { Box, Autocomplete } from "@mui/material";
import PerlTextField from "../../components/PerlTextField";
import PerlLabelMedium from "../../components/PerlLabelMedium";

/**
 * SKUWeightQuestion - Shared question component
 * Used by: F&B, Packaging
 *
 * Number input with unit selector for SKU weight/dimensions
 */
export default function SKUWeightQuestion({
  value,
  onChange,
  unit,
  unitOptions = ["g", "kg", "ml", "L"],
  onUnitChange,
  onAutoAdvance, // Auto-advance handler from ChatInterface
  autoAdvanceOnBlur = false, // Enable auto-advance on blur
  error = "",
}) {
  const handleBlur = () => {
    if (autoAdvanceOnBlur && onAutoAdvance && value && parseFloat(value) > 0) {
      onAutoAdvance();
    }
  };

  return (
    <>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>Enter SKU Weight:</PerlLabelMedium>
      <Box sx={{ display: "flex", gap: 2 }}>
        <PerlTextField
          fullWidth
          type="number"
          placeholder="Enter weight"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={handleBlur}
          error={Boolean(error)}
          helperText={error}
        />
        {unitOptions && unitOptions.length > 0 && (
          <Autocomplete
            value={unit}
            onChange={(event, newValue) => onUnitChange(newValue)}
            options={unitOptions}
            sx={{ minWidth: 100 }}
            renderInput={(params) => <PerlTextField {...params} placeholder="Unit" />}
          />
        )}
      </Box>
    </>
  );
}
